<template>
  <div class="animate-spin h-11 w-11 loader rounded-full"></div>
</template>
<script setup lang="ts">
  import { onMounted } from 'vue'

  const emit = defineEmits<{
    (e: 'setLoadingDone'): void
  }>()

  onMounted(() => {
    setTimeout(() => {
      emit('setLoadingDone')
    }, 4000)
  })
</script>
<style scoped>
  .loader {
    border: 6px solid var(--lp-dark-blue);
    border-top: 6px solid var(--lp-blue);
  }
</style>
